
import ColorsSquare from "../../../assets/filled/ColorsSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ColorsSquareIcon({ className, dataTestid = "ColorsSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ColorsSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
